/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Grid, IconButton, Paper } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { deleteImage, getByIdInvoice } from "app/redux/slice/invoiceSlice";
import { useEffect, useState } from "react";
import { istDateDisplay } from "app/helpers/istDate";

const FilePreview = ({ value, handleSubmit, type }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [invoiceData, setInvoiceData] = useState([]);
  // The LR copy is a single file on the invoice rather than one of the two
  // status-image arrays, so it needs its own section below.
  const lrCopy = invoiceData?.lrCopy?.fileName ? invoiceData.lrCopy : null;
  const lrCopyUrl = lrCopy
    ? `${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${lrCopy.fileName}`
    : null;
  const isLrCopyPdf = Boolean(lrCopy?.fileName?.toLowerCase().endsWith(".pdf"));
  // Payment proof the vendor uploaded from the App - a list of
  // { fileName, originalName, uploadedAt }, kept apart from the documents
  // Admin attaches in the Change Payment Status popup.
  const paymentProofs = invoiceData?.supplierPaymentProofs || [];
  const fileUrl = (fileName) =>
    `${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${fileName}`;

  const validationSchema = Yup.object({
    // status: Yup.string().required("Please enter vendor"),
    // markaNumber: Yup.string().required("Please enter marka number"),
    // file: Yup.mixed().required("A file is required"),
  });

  const handleDelete = (filename) => {
    dispatch(
      deleteImage({
        filename,
        type: "invoice",
        id: value?._id,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          dispatch(getByIdInvoice(value?._id))
            .unwrap()
            .then((response) => {
              if (response.status === 200) {
                setInvoiceData(response?.data?.data?.invoiceDetail);
              } else {
                enqueueSnackbar(response.data?.responseMessage, {
                  variant: "error",
                });
              }
            });
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  useEffect(() => {
    dispatch(getByIdInvoice(value?._id))
      .unwrap()
      .then((response) => {
        if (response.status === 200) {
          setInvoiceData(response?.data?.data?.invoiceDetail);
        } else {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  }, [dispatch, enqueueSnackbar]);

  return (
    <>
      <Formik
        initialValues={{
          status: "",
          files: null,
          markaNumber: invoiceData?.markaNumber,
        }}
        validationSchema={validationSchema}
        onSubmit={async (data, { setSubmitting }) => {
          setSubmitting(true);
          setTimeout(() => {
            handleSubmit(data);
            setSubmitting(false);
          }, 1500);
        }}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            {!invoiceData?.paymentStatusImage?.length &&
              !invoiceData?.dispatchStatusImage?.length &&
              !paymentProofs.length &&
              !lrCopy && <h3>No data available</h3>}
            {paymentProofs.length > 0 && (
              <>
                <h2>Payment Proof (Uploaded by Vendor from App)</h2>
                <Grid container spacing={2} mb={4}>
                  {paymentProofs.map((proof, index) => (
                    <Grid item sm={4} xs={12} key={proof?._id || index}>
                      <Paper
                        elevation={3}
                        style={{
                          position: "relative",
                          borderRadius: "10px",
                          overflow: "hidden",
                          minWidth: "200px",
                        }}
                      >
                        {type !== "view" && (
                          <IconButton
                            aria-label="delete"
                            style={{
                              position: "absolute",
                              top: 4,
                              right: 4,
                              backgroundColor: "rgba(255,255,255,0.8)",
                            }}
                            size="small"
                          >
                            <DeleteIcon
                              onClick={() => handleDelete(proof.fileName)}
                              fontSize="small"
                            />
                          </IconButton>
                        )}
                        <a
                          href={fileUrl(proof.fileName)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {proof.fileName?.toLowerCase().endsWith(".pdf") ? (
                            <div
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                              }}
                            >
                              <Icon
                                icon="fa6-regular:file-pdf"
                                width="100%"
                                height="100px"
                                style={{ color: "#000" }}
                              />
                            </div>
                          ) : (
                            <img
                              src={fileUrl(proof.fileName)}
                              alt={`Payment proof ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "block",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          )}
                        </a>
                      </Paper>
                      <p style={{ margin: "4px 0 0", wordBreak: "break-all" }}>
                        {proof.originalName || proof.fileName}
                      </p>
                      {proof.uploadedAt && (
                        <p
                          style={{
                            margin: 0,
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          Uploaded on {istDateDisplay(proof.uploadedAt)}
                        </p>
                      )}
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
            {lrCopy && (
              <>
                <h2>LR Copy</h2>
                <Grid container spacing={2} mb={4}>
                  <Grid item sm={4} xs={12}>
                    <Paper
                      elevation={3}
                      style={{
                        position: "relative",
                        borderRadius: "10px",
                        overflow: "hidden",
                        minWidth: "200px",
                      }}
                    >
                      {/* View-only: an LR copy is replaced by uploading a new
                          one from the Change Dispatch Status popup, so there is
                          no delete action to leave the record pointing at a
                          file that no longer exists. */}
                      <a
                        href={lrCopyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {isLrCopyPdf ? (
                          <div
                            style={{
                              width: "100%",
                              height: "200px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "4px",
                            }}
                          >
                            <Icon
                              icon="fa6-regular:file-pdf"
                              width="100%"
                              height="100px"
                              style={{ color: "#000" }}
                            />
                          </div>
                        ) : (
                          <img
                            src={lrCopyUrl}
                            alt="LR Copy"
                            style={{
                              width: "100%",
                              height: "200px",
                              display: "block",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        )}
                      </a>
                    </Paper>
                    <p style={{ margin: "4px 0 0", wordBreak: "break-all" }}>
                      {lrCopy.originalName || lrCopy.fileName}
                    </p>
                  </Grid>
                </Grid>
              </>
            )}
            {invoiceData?.paymentStatusImage?.length > 0 && (
              <>
                <h2>Payment Status Documents</h2>
                <Grid container spacing={2} mb={4}>
                  {invoiceData?.paymentStatusImage?.map((img, index) => (
                    <Grid item sm={4} xs={12} key={index}>
                      <Paper
                        elevation={3}
                        style={{
                          position: "relative",
                          borderRadius: "10px",
                          overflow: "hidden",
                          minWidth: "200px",
                        }}
                      >
                        {type !== "view" && (
                          <IconButton
                            aria-label="delete"
                            style={{
                              position: "absolute",
                              top: 4,
                              right: 4,
                              backgroundColor: "rgba(255,255,255,0.8)",
                            }}
                            size="small"
                          >
                            <DeleteIcon
                              onClick={() => handleDelete(img)}
                              fontSize="small"
                            />
                          </IconButton>
                        )}
                        {img.endsWith(".pdf") ? (
                          <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                              }}
                            >
                              <Icon
                                icon="fa6-regular:file-pdf"
                                width="100%"
                                height="100px"
                                style={{ color: "#000" }}
                              />
                            </div>
                          </a>
                        ) : (
                          <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${img}`}
                              alt={`Invoice ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "block",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </a>
                        )}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
            {invoiceData?.dispatchStatusImage?.length > 0 && (
              <>
                <h2 style={{ fontStyle: "" }}>Dispatched Documents</h2>
                <Grid container spacing={2} mb={4}>
                  {invoiceData?.dispatchStatusImage?.map((img, index) => (
                    <Grid item sm={4} xs={12} key={index}>
                      <Paper
                        elevation={3}
                        style={{
                          position: "relative",
                          borderRadius: "10px",
                          overflow: "hidden",
                          minWidth: "200px",
                        }}
                      >
                        {type !== "view" && (
                          <IconButton
                            aria-label="delete"
                            style={{
                              position: "absolute",
                              top: 4,
                              right: 4,
                              backgroundColor: "rgba(255,255,255,0.8)",
                            }}
                            size="small"
                          >
                            <DeleteIcon
                              onClick={() => handleDelete(img)}
                              fontSize="small"
                            />
                          </IconButton>
                        )}
                        {img.endsWith(".pdf") ? (
                          <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                              }}
                            >
                              <Icon
                                icon="fa6-regular:file-pdf"
                                width="100%"
                                height="100px"
                                style={{ color: "#000" }}
                              />
                            </div>
                          </a>
                        ) : (
                          <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_BASE_URL}invoice-images/${img}`}
                              alt={`Invoice ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "block",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </a>
                        )}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FilePreview;
